<script setup lang="ts">
import {
    LazyContentPricingSellerCs,
    LazyContentPricingSellerDe,
    LazyContentPricingSellerEn,
    LazyContentPricingSellerEs,
    LazyContentPricingSellerFr,
    LazyContentPricingSellerIt,
    LazyContentPricingSellerNl,
    LazyContentPricingSellerPl,
    LazyContentPricingSellerPt,
    LazyContentPricingSellerRo,
    LazyContentPricingSellerRu,
} from '#components';
import { Locale } from '~i18n/i18nConfig';

// COMPOSABLES
const { locale, tt } = useTypedI18n();
useSeoMeta({
    title: tt('seo.pricingSeller.title'),
    ogTitle: tt('seo.pricingSeller.title'),
    description: tt('seo.pricingSeller.description'),
    ogDescription: tt('seo.pricingSeller.description'),
});

// DATA
const currentComponent = computed<Component>(() => {
    const componentByLocale: Record<Locale, Component> = {
        [Locale.CS]: LazyContentPricingSellerCs,
        [Locale.DE]: LazyContentPricingSellerDe,
        [Locale.EN]: LazyContentPricingSellerEn,
        [Locale.ES]: LazyContentPricingSellerEs,
        [Locale.FR]: LazyContentPricingSellerFr,
        [Locale.IT]: LazyContentPricingSellerIt,
        [Locale.NL]: LazyContentPricingSellerNl,
        [Locale.PL]: LazyContentPricingSellerPl,
        [Locale.PT]: LazyContentPricingSellerPt,
        [Locale.RO]: LazyContentPricingSellerRo,
        [Locale.RU]: LazyContentPricingSellerRu,
    };

    return componentByLocale[locale.value];
});
</script>

<template>
    <div>
        <component :is="currentComponent" />
    </div>
</template>
